import { gql } from '@apollo/client';

export const GET_UPCOMING_RACES_MINIMAL = gql`
  query GetUpcomingRacesMinimal($limit: Int = 4, $analysisTypeId: Float = 1) {
    upcomingRacesMinimal(limit: $limit, analysisTypeId: $analysisTypeId) {
      race_id
      race_number
      race_time
      meeting {
        meeting_id
        track {
          code
          name
          state
        }
      }
      analysis {
        horse_id
        horse_name
        odds
        confidence
        pick_type
        pick_order
        isConsensusPick
      }
    }
  }
`;
